import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipUnconditionalDiscount = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    Desconto aplicado no momento da prestação do serviço, sem depender de eventos futuros.
                    Este valor é deduzido do valor bruto e reduz a base de cálculo dos impostos.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipUnconditionalDiscount;